import React, { useState } from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown } from "react-bootstrap";
import "./Offices.scss";
import moment from "moment/dist/moment";
import { useStaticQuery, graphql } from "gatsby";
import ReactMarkdown from "react-markdown"
import {
    CONTACT_FORM_PAGE_URL,
    CONTACT_PAGE_URL
} from "@Components/common/site/constants";
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";

import { inViewOptions } from '../../../Components/utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import {ImageModule} from "@Components/common/Image_Module"

const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const titleVariants = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        delay: 0.4,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 1
        }
    }
}

const contentVariants = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        delay: 1,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 1
        }
    }
}

const FilterGallery = (props) => {

    const data = useStaticQuery(graphql`
    query{
      glstrapi {
        offices(publicationState: LIVE, where: {Publish: true}) {
            id
            imagetransforms
            ggfx_results {
                id
                content_type
                transforms
                src_import_url
                src_cftle
                field
            }
            Office_Email
            Office_Address
            Office_Name
            Sales_Phone
            Lettings_Phone
            Office_Image {
                alternativeText
                url
            }
            URL
      
        }
      }
    }
    `);
    const [offices, setoffices] = useState(data.glstrapi?.offices)

    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => {
                return (
                    <motion.section
                        ref={ref}
                        initial="hidden"
                        animate={inView ? "visible" : "hidden"}
                        variants={containerVariants}
                    >
                        <React.Fragment>
                            <section className="offices-section">
                                <Container>
                                    <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                                        <Row>
                                            <Col lg={12}>
                                                <div className="content-how-can-we-help">
                                                    <motion.div variants={titleVariants}>
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                            <h2>{props.Title}<span className="stroke-text">{props.Sub_Title}</span></h2>
                                                        </ScrollAnimation>
                                                    </motion.div>

                                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                        <ReactMarkdown source={props.Content} allowDangerousHtml />
                                                    </ScrollAnimation>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            {offices.map(list => {
                                                let processedImages = JSON.stringify({});
                                                if (list?.imagetransforms?.Image_Transforms) {
                                                    processedImages = list.imagetransforms.Image_Transforms;
                                                }
                                                return (
                                                    <Col lg={6}>
                                                        <motion.div variants={contentVariants}>
                                                            <div className="person-detail">
                                                                <Link to={list.URL}>
                                                                    <div class="office-bk">
                                                                        {/* <picture>
                                                                        <source media="(min-width:992px)" srcSet={list.Office_Image?.url} />
                                                                        <source media="(min-width:768px)" srcSet={list.Office_Image?.url} />
                                                                        <img src={list.Office_Image?.url} alt="" />
                                                                        </picture> */}
                                                                        <ImageModule ImageSrc={list.Office_Image} attr={{ alt: list.Office_Name }} ggfx_results={list.ggfx_results} imagename="offices.Office_Image.listimg" strapi_id={list.id} />

                                                                        {/* <ImageTransform imagesources={list.Office_Image?.url} renderer="srcSet" imagename='offices.Office_Image.listimg'
                                                                            attr={{ alt: list.Office_Image?.alternativeText, className: '' }}
                                                                            imagetransformresult={processedImages} id={list.id} >
                                                                        </ImageTransform> */}
                                                                    </div>
                                                                </Link>
                                                                <ScrollAnimation animateOnce={true} animateIn='fadeIn'><Link to={list.URL}><span className="small-head">{list.Office_Address}</span></Link></ScrollAnimation>
                                                                <ScrollAnimation animateOnce={true} animateIn='fadeIn'><h2><Link className="email-line-height" to={list.URL + CONTACT_FORM_PAGE_URL.alias}>Email {list.Office_Name}</Link> 
                                                                </h2></ScrollAnimation>
                                                                <h4>
                                                    <span className="item-sale">Sales:</span>    
                                                                <a title="Sales" href={"tel:" + list.Sales_Phone}><span className="stroke-text">{list.Sales_Phone}</span></a>
                                                                </h4>
                                                                <h4>
                                                    <span className="item-sale">Lettings:</span>    
                                                                <a title="Lettings" href={"tel:" + list.Lettings_Phone}><span className="stroke-text">{list.Lettings_Phone}</span></a>
                                                                </h4>

                                                                <Link class="btn btn-primary d-md-inline-flex" to={list.URL}>View Office Details</Link>
                                                            </div>
                                                        </motion.div>
                                                    </Col>
                                                )
                                            })
                                            }
                                        </Row>
                                    </ScrollAnimation>
                                </Container>
                            </section>
                        </React.Fragment>
                    </motion.section>
                )
            }}
        </InView>
    )
}

export default FilterGallery;